// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"800":"UploadField","828":"DatetimeField","897":"carousel"}[chunkId] || chunkId) + ".bundle.css";
};